import { Injectable } from '@angular/core';
import { FrequencyFormattingConstants } from './frequency-formatting-constants';

@Injectable({
    providedIn: 'root',
})
export class FrequencyFormattingService {
    /**
     * Returns a string representation of the frequency range.
     * Example (if frequency low and frequency high are present): 150.00000 - 169.99999
     * Example (if frequency low is present and frequency high is not): 150.00000
     * @param frequencyLow
     * @param frequencyHigh
     * @returns
     */
    getFrequencyLabel(
        frequencyLow: number,
        frequencyHigh: number | null,
    ): string {
        return [frequencyLow, frequencyHigh]
            .filter((x) => x !== null)
            .map((x) =>
                x.toFixed(FrequencyFormattingConstants.frequencyDecimalPlaces),
            )
            .join(' - ');
    }

    getFormattedFrequency(frequency: number): string {
        return frequency.toFixed(
            FrequencyFormattingConstants.frequencyDecimalPlaces,
        );
    }
}
